import { render, staticRenderFns } from "./myGoals.vue?vue&type=template&id=280a038a"
import script from "./myGoals.js?vue&type=script&lang=js&external"
export * from "./myGoals.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports